import React from 'react';

const FloatingCallButton = () => {
  const phoneNumber = '+917386770284'; // Replace with your phone number

  const callLink = `tel:${phoneNumber}`;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '80px', // Adjust position to be below WhatsApp icon if both are present
        right: '20px',
        zIndex: '999', // Ensure it's below the WhatsApp button if both are present
        cursor: 'pointer',
      }}
      onClick={() => {
        window.location.href = callLink;
      }}
    >
      {/* You can use an image or an icon here */}
      <img
        src="https://tse1.mm.bing.net/th/id/OIP.FwqfpJeezkFTwdfnQ63pKQHaHk?w=840&h=859&rs=1&pid=ImgDetMain" // Example call icon URL
        alt="Call Us"
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
        }}
      />
    </div>
  );
};

export default FloatingCallButton;